import { render, staticRenderFns } from "./endBox.vue?vue&type=template&id=5d7543fe"
import script from "./endBox.vue?vue&type=script&lang=js"
export * from "./endBox.vue?vue&type=script&lang=js"
import style0 from "./endBox.vue?vue&type=style&index=0&id=5d7543fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports